var libraryCategory = {
    vm: null,
    init: function () {
        this.vm = new Vue({
            el: "#library",
            data: {
                tenantId: window.cateData.DpsTenantId, // DPS租户ID
                schemaId: window.cateData.DpsSchemaId, // DPS体系ID
                categoryId: window.cateData.DpsCategoryId, //文章栏目ID
                tagFieldId: window.cateData.tagFieldId, // DPS关键词标签字段ID
                filterVisible: false, // 标签筛选框显隐
                list: [], // 文章分类列表
                tagList: [], // 标签列表
                tagField: {}, // 标签字段
                selectedTags: [], //选中的标签
                articleList: [], //筛选结果文章列表
                showSearchResultBox: false, // 展示筛选结果内容
                keywords: '', // 标题关键字搜索
                checkedIdArr: [], // 选中的标签ID
                prevKeyWords: '', // 上次搜索关键词
                isHideSomeFiles: false,
                loading: true,
                isPc: $(window).width() > 750
            },
            created: function () {
                if(!this.isPc){
                  this.getCategory(); //获取栏目详情
                }
                this.getGroupList();
                this.getTagList();
                if(getUrlPara('a') === '0distance'){
                    this.isHideSomeFiles = true;
                }
            },
            methods: {
              /*获取栏目详情*/
              getCategory: function () {
                postJson(window.cateData.api.getCategory, {
                    tenantId: this.tenantId,
                    articleCategoryId: this.categoryId,
                    "_cache_with_cached": 1, //是否启用缓存 0/1
                    "_cache_refresh": 0, //是否刷新缓存 0/1
                    "_cache_timeout": 5*60, //缓存过期时间【秒】
                  },
                  function (res) {
                    if (res.body.result == 0) {
                      //微信分享
                      wxShareCom.init({
                        title: res.body.content.shareTitle ? res.body.content.shareTitle : window.cateData.DpsShareTitle, // 分享标题
                        desc: res.body.content.description ? res.body.content.description : window.cateData.DpsShareDesc, // 分享描述
                        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: res.body.content.shareImgUrl ? res.body.content.shareImgUrl : window.location.origin + window.cateData.DpsShareImage // 分享图标
                      })
                    }
                  }
                )
              },
                /* 获取文章分类 */
                getGroupList: function () {
                    var _this = this;
                    postJson(window.cateData.api.getArticleCategoryList, {
                            tenantId: this.tenantId,
                            articleCategoryId: this.categoryId,
                            instanceId: "",
                            moduleId: "",
                            isEnabled: 1,
                            "_cache_with_cached": 1, //是否启用缓存 0/1
                            "_cache_refresh": 0, //是否刷新缓存 0/1
                            "_cache_timeout": 5*60, //缓存过期时间【秒】
                        },
                        function (res) {
                            if (res.body.result == 0) {
                                _this.list = res.body.content || [];
                                _this.list = _this.list.sort(function (a, b) {
                                    return parseInt(a.orderNumber) - parseInt(b.orderNumber);
                                });
                              _this.loading = false
                            }
                        }
                    )
                },
                /* 获取标签列表 */
                getTagList: function () {
                    var _this = this;
                    var params = {
                        tenantId: this.tenantId,
                        isShowTag: 1,
                        type: 'actionTag',
                        "_cache_with_cached": 1, //是否启用缓存 0/1
                        "_cache_refresh": 0, //是否刷新缓存 0/1
                        "_cache_timeout": 5*60, //缓存过期时间【秒】
                    };
                    postJson(window.cateData.api.getTagList, params, function (data) {
                        if (data.body.result == '0') {
                            if (data.body.content.items && data.body.content.items.length) {
                                _this.handleTagData(data.body.content.items);
                            }
                        }
                    });
                },
                /* 处理标签字段 */
                handleTagData: function (data) {
                    var _this = this;
                    _this.tagList = [];
                    data.forEach(function (item) {
                        if (item.tagFieldId == _this.tagFieldId) {
                            if (item.tags && item.tags.length > 0) {
                                item.tags.forEach(function (tag) {
                                    tag.checked = false;
                                    tag.showName = tag.tagName.replace(/_/g, ' ');
                                    _this.tagList.push(tag);
                                });
                            }
                            _this.tagField = item;
                        }
                    });
                    this.autoFilter();
                },
                /* 获取筛选的文章列表 */
                getArticleList: function (tagParams) {
                    var _this = this;
                    _this.articleList = [];
                    var params = {
                        tenantId: this.tenantId,
                        instanceId: '',
                        articleCategoryId: this.categoryId,
                        isTop: -1,
                        isWithStat: 1,
                        isRecommend: -1,
                        hasChildrenCategory: 1,
                        title: this.keywords,
                        tags: tagParams && tagParams.length > 0 ? tagParams : null,
                        start: 0,
                        num: 20,
                        "_cache_with_cached": 1, //是否启用缓存 0/1
                        "_cache_refresh": 0, //是否刷新缓存 0/1
                        "_cache_timeout": 5*60, //缓存过期时间【秒】
                    };
                    postJson(window.cateData.api.getArticleList, params, function (data) {
                        data = data.body;
                        if (data.result == '0') {
                            if (data.content.items && data.content.items.length > 0) {
                                data.content.items.forEach(function (item) {
                                    _this.getArticle(item);
                                });
                            }
                        }
                    });
                },
                /* 获取文章详情 */
                getArticle: function (article) {
                    var _this = this;
                    var params = {
                        tenantId: this.tenantId,
                        articleId: article.id,
                        isWithStat: 0,
                        isScroll: 0,
                        isWithTag: 1,
                        globalUserId: getCookie('globalUserId'),
                        "_cache_with_cached": 1, //是否启用缓存 0/1
                        "_cache_refresh": 0, //是否刷新缓存 0/1
                        "_cache_timeout": 5*60, //缓存过期时间【秒】
                    };
                    postJson(window.cateData.api.getArticle, params, function (data) {
                        console.log(data, '---------=========')
                        if (data.body.result == '0') {
                            _this.handleArticleData(data.body.content,article);
                        }
                    });
                },
                handleArticleData: function (data,item) {
                    var _this = this;
                    data.id = item.id;
                    if (data.extra && data.extra.length > 0) {
                        data.extra.forEach(function (ex) {
                            if (ex.title == '文件类型') {
                                switch (ex.value) {
                                    case '图文消息':
                                        data.articleType = 'imgText';
                                        break;
                                    case '视频':
                                        data.articleType = 'video';
                                        break;
                                    case 'PDF文件':
                                        data.articleType = 'pdf';
                                        break;
                                    default:
                                        data.articleType = ex.value;
                                        break;
                                }
                            } else {
                                data[ex.title] = ex.value;
                            }
                        });
                    }

                    data.tagArr = [];
                    if (data.tagFields && data.tagFields.length > 0) {
                        data.tagFields.forEach(function (tf) {
                            if (tf.tagFieldId == _this.tagFieldId) {
                                tf.tags.forEach(function (tag) {
                                    tag.showName = tag.tagName.replace(/_/g, ' ');
                                });
                                data.tagArr = tf.tags;
                            }
                        });
                    }
                    _this.articleList.push(data);
                },
                /* 控制搜索框显隐 */
                toggleFilterBox: function (type) {
                    this.filterVisible = !this.filterVisible;
                    if(!this.isPc){
                      if (this.filterVisible) {
                        //禁止后方滚动
                        setScroll.unScroll();
                      } else {
                        //允许后方滚动
                        setScroll.removeUnScroll();
                        if (type == 'cancel') {
                          var _this = this;
                          this.selectedTags.forEach(function (sTag) {
                            _this.checkedIdArr.push(sTag.tagId);
                          });
                          this.tagList.forEach(function (tag) {
                            if (_this.checkedIdArr.indexOf(tag.tagId) == -1) {
                              tag.checked = false;
                            }
                          });
                        }
                      }
                    }
                },
                /* 筛选 */
                doneFilter: function () {
                    var _this = this;
                    this.toggleFilterBox();
                    this.selectedTags = [];
                    this.tagList.forEach(function (tag) {
                        if (tag.checked) {
                            _this.selectedTags.push(tag);
                        }
                    });
                    this.organizeTagParams();
                },
                autoFilter: function(){
                    var tags = getUrlPara('tags');
                    var _this = this;
                    if (tags){
                        tags = tags.split(',');
                        this.tagList.forEach(function (tag) {
                            if (tags.indexOf(tag.tagName) > -1) {
                                tag.checked = true;
                                _this.selectedTags.push(tag);
                            }
                        });
                        this.organizeTagParams();
                    }
                },
                /* 组织筛选数据 */
                organizeTagParams: function () {
                    var _this = this, tagParams = [], json = {};
                    if (!this.keywords && this.selectedTags.length == 0) {
                        this.showSearchResultBox = false;
                    } else {
                        this.showSearchResultBox = true;
                        if (this.selectedTags.length > 0) {
                            json[_this.tagField.fieldName] = [];
                            this.selectedTags.forEach(function (tag) {
                                json[_this.tagField.fieldName].push(tag.tagName);
                            });
                            tagParams.push(json);
                        }
                        this.getArticleList(tagParams);
                    }
                },
                /* 移除已选中标签 */
                removeTag: function (tag) {
                    var _this = this;
                    this.selectedTags.forEach(function (sTag, index) {
                        if (tag.tagId == sTag.tagId) {
                            sTag.checked = false;
                            _this.selectedTags.splice(index, 1);
                        }
                    });
                    this.organizeTagParams();
                },
                /* 输入框触发筛选 */
                searchByKeyword: function() {
                    // 关键词和上次输入没有改变时，不触发筛选
                    if (this.prevKeyWords != this.keywords) {
                        this.prevKeyWords = this.keywords;
                        this.organizeTagParams();
                    }
                },
                gotoList: function (item) {
                    gioTrackAction.gio_base('dps_librarylistclick',{
                        librarylisttitle: item.title
                    })
                    gotoUrlSmart('/campaign/dps_library/list/' + item.articleCategoryId + window.location.search)
                },
                /* 跳转详情页 */
                viewDetail: function (item) {
                    switch (item.articleType) {
                        case 'imgText':
                            if (item.linkUrl && item.linkUrl != 'http://') {
                                gotoUrlSmart(item.linkUrl);
                            } else {
                                // window.location.href = ;
                                gotoUrlSmart('/campaign/dps_library/details/' + item.id + window.location.search)
                            }
                            break;
                        case 'video':
                            if (item.id) {
                                gotoUrlSmart( '/campaign/dps_library/details' + item.fileIds.split('|')[0] + '/' + item.id);
                            }
                            else if (item.linkUrl && item.linkUrl != 'http://') {
                                filelist.video(item.linkUrl, item.title, '0', '157452', '/view-157452.html')
                            } else {
                                msg.toast('暂无video文件')
                            }
                            break;
                        case 'pdf':
                            if (item.fileIds) {
                                // window.location.href =;
                                gotoUrlSmart( '/campaign/dps_library/' + item.fileIds.split('|')[0] + '/' + item.id + window.location.search);
                            } else {
                                msg.toast('暂无pdf文件')
                            }
                            break;
                        case 'webinar':
                            if (item.linkUrl && item.linkUrl != 'http://') {
                                // window.location.href = item.linkUrl;
                                gotoUrlSmart(item.linkUrl);
                            } else {
                                msg.toast('暂无webinar')
                            }
                            break;
                        default:
                            msg.toast('没有配置详情')
                            break;
                    }
                },
                showFilterTip: function () {
                    var content = '可在搜索框中输入标题关键词或点击筛选选择文件的标签进行搜索，如：在搜索框可输入DP4400搜索文件，或点击筛选后选择DP4400搜索文件';
                    msg.dialog(content, null, null, '搜索/筛选说明', true, null, null, 'r-tip-dialog');
                }
            },
        })
    },
    goPrevBack: function () {
        if (this.vm.showSearchResultBox) {
            this.vm.keywords = '';
            this.vm.prevKeyWords = '';
            this.vm.showSearchResultBox = false;
            this.vm.tagList.forEach(function (tag) {
                tag.checked = false;
            });
        } else {
            if(document.referrer === '' || document.referrer.indexOf(solution_m_host) === -1){ //如果上一页为空或不是手机端的页面
                window.location.href = window.rootUrl;
            }else{
                window.history.back();
            }
        }
    }
};
